import { Link } from 'react-router-dom';
import { blogArticles } from '@/constants/blogArticles';
import { ArrowRight } from 'lucide-react';
import { formatBlogDate, getBlogDateTimestamp } from '@/utils/dateFormat';

const BlogPreviewSection = () => {
  const latestArticles = [...blogArticles]
    .sort((a, b) => getBlogDateTimestamp(b.date) - getBlogDateTimestamp(a.date))
    .slice(0, 3);

  return (
    <section className="section-shell relative pb-12 pt-24">
      <div className="container mx-auto px-6">
        <div className="mb-10 text-center">
          <h2 className="display-title text-foreground mb-4">
            Nos derniers articles
          </h2>
          <p className="text-lg text-foreground/60 max-w-xl mx-auto">
            Conseils déco, idées cadeaux et guides pour sublimer votre intérieur
            avec un tableau personnalisé.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl mx-auto">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group rounded-[1.6rem] border border-white/60 bg-white/60 p-6 shadow-card backdrop-blur-md hover:bg-white/80 transition-all hover:shadow-lg block"
            >
              <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
                {article.categoryLabel}
              </span>
              <h3 className="font-semibold text-foreground mt-3 mb-2 group-hover:text-primary transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-foreground/55 leading-6 line-clamp-3 mb-4">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-2 text-xs text-foreground/40">
                <span>
                  {formatBlogDate(article.date)}
                </span>
                <span>· {article.readingTime} min</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <div className="inline-flex flex-col items-center gap-3 sm:flex-row">
            <Link
              to="/tableau-photo-personnalise"
              className="inline-flex items-center gap-2 rounded-full border border-primary/15 bg-white/65 px-5 py-3 text-sm font-medium text-primary shadow-card hover:gap-3 transition-all"
            >
              Guide tableau photo personnalisé
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:gap-3 transition-all"
            >
              Voir tous les articles
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;
